import { RootState } from '..'
import { findItemByUuid } from './reportsSlice'
import { v4 as uuidv4 } from 'uuid'


const requiresTriage = (state: RootState) => state.reports.requiresTriage
const requiresTriageIsLoading = (state: RootState) => state.reports.requiresTriageLoading
const userCasesIsLoading = (state: RootState) => state.reports.userCasesLoading
const immediateAttention = (state: RootState) => state.reports.immediateAttention
const additionalInformationRequired = (state: RootState) =>
  state.reports.additionalInformationRequired
const addressedAndResolved = (state: RootState) => state.reports.addressedAndResolved
const addressedAndResolvedLoading = (state: RootState) => state.reports.addressedAndResolvedLoading
const assignedToMeForTriage = (state: RootState) => state.reports.assignedToMeForTriage
const acceptedReports = (state: RootState) => state.reports.acceptedReports
const selectedReport = (state: RootState) => state.reports.openedCase
const reportAnswers = (state: RootState) => state.reports.reportAnswers
const caseTypeQuestions = (state: RootState) => state.reports.caseTypeQuestions
const caseIsOpening = (state: RootState) => state?.reports?.caseIsOpening
const reportCaseTypes = (state: RootState) =>
  state?.reports?.openedCase?.types.filter(
    caseType => caseType?.text !== 'OSHA' && caseType?.text !== 'REPORTER',
  )
const answersToCaseTypeQuestion = (uuid: string) => (state: RootState) => {
  return findItemByUuid(state.reports?.caseTypeQuestionAnswers, uuid)
}


const createOrFindSubanswerByUuid = (uuid: string, parent: any) => (state: RootState) => {
  
  if (!parent) {
    return null
  }
  
  let subanswer = findItemByUuid(parent?.subanswers, uuid)
  if (subanswer) {
    return subanswer
  }

  const baseSubanswer = findItemByUuid(state.reports?.caseTypeQuestionAnswers, uuid)
  if (baseSubanswer) {
    subanswer = {...baseSubanswer, uuid: uuidv4()} 
    parent.subanswers.push(subanswer)
  }
  return subanswer
}
const answersDefault = (state: RootState) => state.reports?.caseTypeQuestionAnswers
const caseQuestionsNumberOfChanges = (state: RootState) => state?.reports?.numberOfChanges

export default {
  requiresTriage,
  immediateAttention,
  additionalInformationRequired,
  addressedAndResolved,
  addressedAndResolvedLoading,
  assignedToMeForTriage,
  acceptedReports,
  selectedReport,
  reportAnswers,
  caseTypeQuestions,
  caseIsOpening,
  reportCaseTypes,
  answersToCaseTypeQuestion,
  answersDefault,
  caseQuestionsNumberOfChanges,
  createOrFindSubanswerByUuid,
  requiresTriageIsLoading,
  userCasesIsLoading,
}
